import { useTranslation } from '@/i18n/useTranslation';

import { useState, type FormEvent } from 'react';
import { useAuth } from '@/auth/useAuth';
import { LanguageToggle } from '@/components/layout/LanguageToggle';

export function LoginPage() {
  const { t } = useTranslation();
  const { login } = useAuth();
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [pending, setPending] = useState(false);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setPending(true);
    setError(false);
    try {
      await login(identifier, password);
    } catch {
      setError(true);
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-page__visual" aria-hidden="true">
        <div className="login-page__visual-copy">
          <span>{t('QUALITY / DELIVERY / TRUST')}</span>
          <strong>{t('Protecting quality through every process.')}</strong>
        </div>
      </div>
      <div className="login-page__panel">
        <div className="login-page__card">
          <div className="login-page__language">
            <LanguageToggle />
          </div>
          <img src="/sanwa-kenko-logo.png" alt={t('Sanwa Kenko')} className="login-page__logo" />
          <div className="login-page__heading">
            <span className="section-kicker">{t('QUALITY OPERATIONS')}</span>
            <h1>{t('Paint Defect Inspection Platform')}</h1>
            <p>{t('Sign in with your back-office account to continue.')}</p>
          </div>
          <form onSubmit={(event) => void submit(event)} className="stack">
            <label className="field">
              <span className="field__label">{t('Username or email')}</span>
              <input
                className="input"
                type="text"
                autoComplete="username"
                required
                value={identifier}
                onChange={(event) => setIdentifier(event.target.value)}
              />
            </label>
            <label className="field">
              <span className="field__label">{t('Password')}</span>
              <input
                className="input"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            </label>
            {error && (
              <p role="alert">{t('Sign-in failed. Check your username or email and password.')}</p>
            )}
            <button
              type="submit"
              className="btn btn--primary login-page__button"
              disabled={pending}
            >
              {pending ? t('Signing in…') : t('Sign in')}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
